module.exports = __webpack_public_path__ + "img/target-color.e42e07fc.png";